<template>
  <v-container 
    fluid 
    class="pa-0"
    :key="componentKey"
  >
    <v-row 
      style="width: 100%" 
      class="ma-0"
      justify='center'
    >
      <v-col
        :cols="12"
        :sm="12"
        :md="6"
        :lg="6"
        v-for="article in articles"
        v-bind:key="article[identifierKey]"
      >
        <div class="d-flex justify-center">
          <ArticlePreview
            :title="article.title"
            :description="article.description"
            :author="article.author"
            :publication-date="article.publicationDate"
            :avatar-url="article.avatarUrl"
            :image-url="article.imageUrl"
            v-on:title-click="emit('title-click', article)"
            v-on:description-click="emit('description-click', article)"
            v-on:avatar-click="emit('avatar-click', article)"
            v-on:action-click="emit('action-click', article)"
          >
            <template v-slot:actions>
              <slot name="actions" v-bind:article="article">
              </slot>
            </template>
            <template v-slot:description>
              <slot name="description" v-bind:article="article">
              </slot>
            </template>
            <template v-slot:title>
              <slot name="title" v-bind:article="article">
              </slot>
            </template>
          </ArticlePreview>
        </div>
      </v-col>
      <v-col v-if="articles.length % 2 != 0"></v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex justify-center align-center">
          <v-btn
            icon
            :loading="loadingMore"
            v-if="!finishLoading"
            @click="loadMore"
          >
            <v-icon>{{loadMoreIcon}}</v-icon>
          </v-btn>
          <span v-else class="font-weight-light">
            {{articles.length}} di {{articles.length}}
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ArticlePreview from "../articlePreview"
import emittable from "../../../mixins/emittable"

import {
  VContainer,
  VRow,
  VCol,
  VBtn,
  VIcon
} from 'vuetify/lib'

export default {
  name: "ArticlesList",
  components: {
    ArticlePreview,
    VContainer,
    VRow,
    VCol,
    VBtn,
    VIcon
  },
  mixins: [emittable],
  data: function() {
    return {
      componentKey: 0
    }
  },
  props: {
    articles: {
      type: Array,
      default: function() {
        return []
      }
    },
    identifierKey: {
      type: String,
      default: 'title'
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    finishLoading: {
      type: Boolean,
      default: false
    },
    loadMoreIcon: {
      type: String,
      default: 'mdi-reload'
    },
  },
  methods: {
    loadMore() {
      this.emit('load-more', this.articles.length)
    }
  },
  watch: {
    articles() {
      this.componentKey++
    }
  }
}
</script>

<style>

</style>